<template>
  <el-table-column
    prop="car.plate_number"
    sortable="custom"
    label="Gépjármű"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.car.plate_number }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'car.plate_number',
  };
</script>
